import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RootState } from "../../../../store/index.store";
import { assignPageSelectors } from "../../assign-page.selector";
import { assignPageActions } from "../../assign-page.store";
import { AssignFilter as AssignFilterComponent } from "./AssignFilter";

const mapStateToProps = (state: RootState) => ({
  filters: assignPageSelectors.getFilters(state),
  selectedFilterId: assignPageSelectors.getSelectedFilterId(state)
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  filterChanged: (selectedFilterId: string) =>
    dispatch(assignPageActions.USER_CHANGE_ASSIGN_FILTER({ selectedFilterId }))
});

export const AssignFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignFilterComponent);
